<template>
  <div>
    <v-container>
      <v-card class="mx-auto my-5" max-width="2500">
        <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
          Habilitación de cupos</v-system-bar>
      </v-card>
      <v-card class="mx-auto my-5 elevation-1" max-width="2100">
        <v-row class="start" style="margin: 1rem 0">
          <v-col cols="6" sm="3" md="3">
            <v-text-field max-width="200" class="mx-3" v-model="searchClinica" label="Clínica"
              prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <v-text-field max-width="200" class="mx-3" v-model="searchDistrito" label="Distrito"
              prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="6" sm="2" md="2">
            <v-autocomplete max-width="200" class="mx-3" v-model="searchTurno" label="Turno"
              :items="['TURNO 1', 'TURNO 2', 'TURNO 3', 'TURNO 4']" prepend-inner-icon="mdi-magnify" variant="outlined"
              hide-details single-line></v-autocomplete>
          </v-col>
          <v-col cols="6" sm="2" md="2">
            <v-autocomplete max-width="200" class="mx-3" v-model="searchFrecuencia" label="Frecuencia"
              :items="['LUN-MIE-VIE', 'MAR-JUE-SAB', 'MAR-JUE', 'LUN-SAB']" prepend-inner-icon="mdi-magnify"
              variant="outlined" hide-details single-line></v-autocomplete>
          </v-col>
          <v-col cols="6" sm="2" md="2">
            <v-autocomplete max-width="200" class="mx-3" v-model="searchTipoPuesto" label="Serología"
              :items="['NEGATIVO', 'C POSITIVO']" prepend-inner-icon="mdi-magnify" variant="outlined" hide-details
              single-line></v-autocomplete>
          </v-col>
          <v-col cols="6" sm="2" md="2">
            <v-autocomplete max-width="200" class="mx-3" v-model="searchEstado" label="Habilitado"
              :items="[{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }]" item-value="value"
              item-text="text" prepend-inner-icon="mdi-magnify" variant="outlined" hide-details @change="prueba"
              single-line></v-autocomplete>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mx-auto my-5" max-width="2500">
        <v-data-table :headers="header" :items="filteredData" class="elevation-1" :search="searchClinica">
          <template v-slot:[`item.estado`]="{ item }">
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-checkbox style="margin: 0;" v-model="item.estado" @click="loadEstado(item.estado, item.idCupo)"
                  v-bind="attrs" v-on="on">
                </v-checkbox>
              </template>
              <span>Hola</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="#1973a5" dark>
          <v-card-text>
            Cargando Datos
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEdit" v-if="dialogEdit" max-width="500px">
        <FormMedico @closeEdit="closeEdit" />
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import FormMedico from "./form.vue"

export default {
  data() {
    return {
      dialogEdit: false,
      dialogLoader: false,
      searchFrecuencia: null,
      searchTipoPuesto: null,
      searchTurno: null,
      searchClinica: null,
      searchEstado: null,
      searchDistrito: null,
      header: [
        { text: "Clínica", value: "descripCas" },
        { text: "Distrito", value: "distrito" },
        { text: "Turno", value: "turno" },
        { text: "Frecuencia", value: "frecuencia" },
        { text: "Serología", value: "tipoPuesto" },
        { text: "Número puesto", value: "numeroPuesto", align: "center", headerAlign: "center" },
        { text: "Habilitado", value: "estado" }
      ],
      desserts: []
    }
  },
  methods: {
    prueba() {
      console.log("prueba de activos", this.searchEstado)
    },
    openEdit() {
      this.dialogEdit = true;
    },
    closeEdit() {
      this.dialogEdit = false;
      this.listarCupos();
    },
    loadEstado(status, idCupo) {
      console.log("itemssss", status)
      console.log("itemssssCupos", idCupo)
      /* generar_actualizar_cupo */
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_actualizar_cupo/",
              {
                id_parameCentroPuesto: idCupo,
                estado: status
              },
              {
                headers: { Authorization: this.auth },
              })
            .then((res) => {
              this.dialogLoader = false;
              /* this.desserts=res.data; */
            })
            .catch((res) => {
              this.dialogLoader = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    listarCupos() {
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_lista_cupos/", {},
              {
                headers: { Authorization: this.auth },
              })
            .then((res) => {
              this.dialogLoader = false;
              this.desserts = res.data;
            })
            .catch((res) => {
              this.dialogLoader = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    }
  },
  mounted() {
    if (!sessionStorage.getItem("keyValue")) {
      this.$router.push("/");
    }
  },
  computed: {
    filteredData() {
      if (!this.searchClinica && !this.searchTurno && !this.searchFrecuencia && !this.searchTipoPuesto && this.searchEstado == null && !this.searchDistrito) {
        return this.desserts;
      }
      let filtered = this.desserts;
      if (this.searchClinica) {
        filtered = filtered.filter((item) =>
          item.descripCas
            .toLowerCase()
            .includes(this.searchClinica.toLowerCase())
        );
      }
      if (this.searchTurno) {
        filtered = filtered.filter((item) =>
          item.turno
            .toLowerCase()
            .includes(this.searchTurno.toLowerCase())
        );
      }
      if (this.searchFrecuencia) {
        filtered = filtered.filter((item) =>
          item.frecuencia
            .toLowerCase()
            .includes(this.searchFrecuencia.toLowerCase())
        );
      }

      if (this.searchTipoPuesto) {
        filtered = filtered.filter((item) =>
          item.tipoPuesto
            .toLowerCase()
            .includes(this.searchTipoPuesto.toLowerCase())
        );
      }
      if (this.searchEstado !== null) {
        filtered = filtered.filter((item) =>
          item.estado == this.searchEstado
        );
      }
      if (this.searchDistrito) {
        filtered = filtered.filter((item) =>
          item.distrito
            .toLowerCase()
            .includes(this.searchDistrito.toLowerCase())
        );
      }
      return filtered;
    },
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
    this.url = sessionStorage.getItem("url");
    this.usuario = sessionStorage.getItem("usuario");
    //INICIO DE CONSULTA
    this.listarCupos();
  },
  components: {
    FormMedico
  },
};
</script>